export default __webpack_public_path__ + "static/media/cluster-icon.e21c8357.svg";